export default {"src":"/_next/static/media/about-us.9081a1c3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};